<pg-header
  title="Streets"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="strtLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="(USER_PERMISSIONS.exprt_in==1)?true:false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.updt_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit',data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.dlte_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete',data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="mcrpckMrgn">
      <div class="inptLbl">Street Name</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="strtDt.strt_nm"
          placeholder="please enter street name"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">ULB</div>
      <input
        placeholder="Select ulb"
        nz-input
        [(ngModel)]="strtDt.ulb_nm"
        (ngModelChange)="onulbChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (d of ulbs; track d) {
        <nz-auto-option [nzValue]="d.ulb_id" (click)="getULBID(d.ulb_id);"
          >{{d.ulb_nm}}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">Micropockets</div>
      <input
        placeholder="Select micropockets"
        nz-input
        [(ngModel)]="strtDt.mcrpt_nm"
        [nzAutocomplete]="mpauto"
      />
      <nz-autocomplete #mpauto>
        @for (d of micropockets; track d) {
        <nz-auto-option [nzValue]="d.mcrpt_id">{{d.mcrpt_nm}}</nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <!-- <div class="inptLbl">Description</div>
        <nz-input-wrapper [nzSuffix]="inputClearTpl">
          <input type="text" nz-input [(ngModel)]="strtDt.strt_nm" placeholder="please describe street " />
        </nz-input-wrapper>
        <div class="inptLbl">Start Gate number</div>
        <nz-input-wrapper [nzSuffix]="inputClearTpl">
          <input type="text" nz-input [(ngModel)]="strtDt.strt_nm" placeholder="please enter Start Gate number" />
        </nz-input-wrapper>
        <div class="inptLbl">End Gate number</div>
        <nz-input-wrapper [nzSuffix]="inputClearTpl">
          <input type="text" nz-input [(ngModel)]="strtDt.strt_nm" placeholder="please enter End Gate number" />
        </nz-input-wrapper> -->
    <div class="mcrpckMrgn">
      <div class="inptLbl">Gates count</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="strtDt.estmd_gte_ct"
          placeholder="please enter Gates count"
        />
      </nz-input-wrapper>
    </div>
    <div class="mcrpckMrgn">
      <div class="inptLbl">Household count</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="strtDt.estmd_hse_hld_ct"
          placeholder="please enter End Gate number"
        />
      </nz-input-wrapper>
    </div>
    <ng-template #inputClearTpl
      >@if (strtDt) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="strtDt = {}"
      ></i>
      }</ng-template
    >
    @if (shwStrtEditDiv==false && shwStrtDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveStrt()">
      Submit
    </button>
    } @if (shwStrtEditDiv==true && shwStrtDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveEditStrt()">
      Update
    </button>
    } @if (shwStrtEditDiv==false && shwStrtDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this street?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeleteStrt()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
  <!-- </div>
  </div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
